import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
//import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver'; // Necesitas instalar esta biblioteca
import { HttpClient } from '@angular/common/http';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EvaluacionEtService } from '../../../services/evaluacion-et.service';
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';
import { appsettings } from '../../../settings/appsettings';



@Component({
  selector: 'app-estudio-cumplmiento',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule],
  templateUrl: './estudio-cumplmiento.component.html',
  styleUrl: './estudio-cumplmiento.component.css'
})
export class EstudioCumplmientoComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;

  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  sel_edo!: number;
  estado: any = [];

  private srvLogin = inject(InicioService);
  private servicios = inject(EvaluacionEtService);
  private http = inject(HttpClient);
  url = appsettings.apiUrl;

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }


  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarEstudioCumplimiento('1','1').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = 1;
        this.resultado = rs.data['empresas'];
        console.log('prueba:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  // Método para filtrar la tabla
  buscar() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre ? this.quitarAcentos(item.nombre.toLowerCase()) : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term) ||
        estado.includes(term)
      );
    });
  }
  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  consulta_combos(){
    let estado = (document.getElementById('estado') as HTMLInputElement);
    this.mdl.cargando();
    this.servicios.listarEstudioCumplimiento(estado.value,'1').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = parseInt(estado.value);
        this.resultado = rs.data['empresas'];
        console.log('prueba222222:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  imprimir(id_organizacion: string){
    this.mdl.cargando();
    this.servicios.imprimir(id_organizacion).subscribe({
      next: (rs) => {
        this.mdl.cerrar();

        const ruta = `${this.url}/${rs.data[0]}`
        // Abre la URL en una nueva pestaña
        console.log('ruta: ',rs.data[0])

        if(rs.data[0] == null){
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Error al imprimir.';
          this.mdl.alerta();
        }
        else{
          this.http.get(ruta, { responseType: 'blob' }).subscribe(
            (response: Blob) => {
              // Usa la biblioteca file-saver para guardar el blob como un archivo
              saveAs(response, `estudio_de_cumplimiento.pdf`);
              console.log('PDF descargado con éxito.');

              this.servicios.borrarDocumento(id_organizacion).subscribe({
                next: (rs) => {
                  console.log('aaaaaa: ',rs.data)
                },
                error: (error) => {
                  this.errorMessage = error.message; // Muestra el mensaje de error al usuario
                }
              });

            },
            (error) => {
              console.error('Error al descargar el PDF:', error);
            }
          );
        }

      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


}
